import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthService } from '../services/api-services/index.service';
import { environment } from 'src/environments/environment';
import { HelperService } from '../services/helper.service';
import { FormService } from '../services/form.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(public toastrService: ToastrService,
    public helperService: HelperService,
    public authService: AuthService,
    private router: Router,
    public formService: FormService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addHeaders(request);
    if (window.location.origin.match('https://localhost') || window.location.origin.match('netlify') || localStorage.getItem('isLog')) {
      if ((request.method == "POST" || request.method == "PUT") && (!request.url.match('assets/media/icons'))) {
        console.group(request.url);
        console.info(JSON.stringify(request.body, null, 2));
        console.groupEnd();
      }
    }
    if (request.body && !(request.body instanceof FormData)) {
      if(this.helperService.getServerLocation() == 9){
        request = request.clone({
          body: request.body
        });
      }else{
        request = request.clone({
          body: { RequestData: this.helperService.getBase64(JSON.stringify(request.body),this.formService.selectedLocation.value) }
        });
      }

    }
    return next.handle(request).pipe(
      // retry(1),
      tap((event) => {
        //logging the http response to browser's console in case of a success
        if (event instanceof HttpResponse && (!event.url!.match('assets/media/icons'))) {
          if (window.location.origin.match('https://localhost') || window.location.origin.match('netlify') || localStorage.getItem('isLog')) {
            console.group(event.url);
            console.info(event);
            console.groupEnd();
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          if (localStorage.getItem('userObj')) {
            localStorage.removeItem('userObj')
            localStorage.removeItem('tenant')
            localStorage.removeItem('parentTenant');
            localStorage.removeItem('serverLocation');
            this.authService.SignOutFirebase()
            location.reload()
            // this.router.navigate(['/auth/login'])
          }
        }
        else {
          //error
        }
        console.warn(error)
        this.router.navigate(['/auth/login'])
        return throwError(error.error);
      })
    )
  }
  addHeaders(request: HttpRequest<any>) {
    if (request.url.match('/admin/auth/jump_cloud_login')) {
      let authToken: string = this.helperService.getSessionStorage('jumpcloudToken');
      request = request.clone({ headers: request.headers.set('AuthToken', this.helperService.encrypt(authToken)) });
      request = request.clone({ headers: request.headers.set('AuthKey', environment.AuthKeyJumpcloud) });
    }
    else if (request.url.match('/admin/auth/okta_login')) {
      let authToken: string = this.helperService.getSessionStorage('oktaToken');
      request = request.clone({ headers: request.headers.set('AuthToken', authToken) });
      request = request.clone({ headers: request.headers.set('AuthKey', environment.AuthKeyOkta) });
    }
    else if (request.url.match('/admin/auth/google_workspace_login')) {
      let authToken: string = this.helperService.getSessionStorage('googleWorkspaceToken');
      request = request.clone({ headers: request.headers.set('AuthToken', this.helperService.encrypt(authToken)) });
      request = request.clone({ headers: request.headers.set('AuthKey', environment.AuthKeyGoogleWorkspace) });
    }
    else if (request.url.match('/admin/get/tenant/dashboard')) {
      let tenant = localStorage.getItem('tenant') ? localStorage.getItem('tenant') : 'pl'
      let obj: any = this.helperService.getLocalStorage('userObj');
      request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${obj.token}`) });
      request = request.clone({ headers: request.headers.set('Accept-Tenant', `${tenant == 'pl' ? 'sl' : 'pl'}`) });
      request = request.clone({ headers: request.headers.set('Accept-Province', `${localStorage.getItem('serverLocation') ? localStorage.getItem('serverLocation') : 1}`) });
    }
    else if (request.url.match(environment.apiUrl)) {
      let obj: any = this.helperService.getLocalStorage('userObj');
      request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${obj.token}`) });
      request = request.clone({ headers: request.headers.set('Accept-Tenant', `${localStorage.getItem('tenant') ? localStorage.getItem('tenant') : 'pl'}`) });
      request = request.clone({ headers: request.headers.set('Accept-Province', `${localStorage.getItem('serverLocation') ? localStorage.getItem('serverLocation') : 1}`) });
    }
    return request;
  }
}
